import { render, staticRenderFns } from "./LearningItemMember.vue?vue&type=template&id=283f4427&"
import script from "./LearningItemMember.vue?vue&type=script&lang=js&"
export * from "./LearningItemMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports